import { render, staticRenderFns } from "./UserFormSectionHeading.vue?vue&type=template&id=e710e738"
import script from "./UserFormSectionHeading.vue?vue&type=script&lang=js"
export * from "./UserFormSectionHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports